import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { Skeleton } from '../../../../atoms/Skeleton';

const useStyles = makeStyles((theme: Theme) => ({
  bottomSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 'auto',
  },
  buttonSkeleton: {
    width: 80,
  },
  descriptionSkeleton: {
    width: '50%',
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
  },
  priceSkeleton: {
    marginRight: theme.spacing(1.25),
    width: 50,
  },
  reorderCardSkeleton: {
    background: theme.palette.common.white,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: 126,
    padding: theme.spacing(1.5),
    marginRight: theme.spacing(1.25),
    minWidth: 280,
  },
  root: {
    background: theme.palette.grey[200],
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflowX: 'hidden',
    padding: theme.spacing(1.5, 1.875, 1.875, 1.875),
  },
  title: {
    width: 140,
    marginBottom: theme.spacing(0.75),
  },
  titleSkeleton: {
    width: '100%',
  },

  topSection: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export function ReorderSkeleton(): JSX.Element {
  const classes = useStyles();
  const rootStyles = clsx('fd-reorder-skeleton', classes.root);

  const renderCardSkeleton = (): JSX.Element => (
    <div className={classes.reorderCardSkeleton}>
      <div className={classes.topSection}>
        <Skeleton className={classes.titleSkeleton} />
        <Skeleton className={classes.titleSkeleton} />
      </div>
      <div className={classes.bottomSection}>
        <Skeleton className={classes.priceSkeleton} />
        <Skeleton className={classes.buttonSkeleton} />
      </div>
    </div>
  );

  return (
    <div className={rootStyles} data-fd="reorder-skeleton">
      <div className={classes.title}>
        <Skeleton className={classes.titleSkeleton} />
      </div>
      <div className={classes.list}>
        {renderCardSkeleton()}
        {renderCardSkeleton()}
        {renderCardSkeleton()}
      </div>
    </div>
  );
}
